// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WBT6","label":"styles_label__1RHy7"};